import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, StackProps, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import ReactHtmlParser from "html-react-parser";
import { Nullable } from "store/types";
import { BaseModal } from "store/types/modals";

import { useDevice, useModals } from "../../../hooks";

const containerStyle: StackProps["sx"] = {
  position: "absolute" as "absolute",
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
  bgcolor: "white",
  minWidth: "550px",
  maxWidth: "802px",
  p: "20px",
  gap: "20px",
  borderRadius: "8px",
  boxShadow:
    "0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)"
};

export const InfoModal: React.FC<{ data: Nullable<BaseModal & { buttonText?: string; isHTML?: boolean; footerMsg?: string }> }> = ({
  data
}) => {
  const { closeInfoModal } = useModals();
  const { isMobile } = useDevice();
  return (
    <Modal open={!!data} onClose={closeInfoModal}>
      <Stack sx={{ ...containerStyle, ...(isMobile && { maxWidth: "95%", minWidth: "95%" }) }}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center", pb: "8px", borderBottom: "1px solid #DBE8F5" }}
        >
          <Typography>{data?.title || "INFO"}</Typography>
          <IconButton size="sm" onClick={closeInfoModal}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack 
          flexDirection="column" 
          justifyContent="space-between" 
          alignItems="center" 
          minHeight="100px" 
          maxHeight="calc(100vh - 200px)"
          gap="20px"
          sx={{ overflow: "hidden" }}
        >
          <Stack sx={{ width: "100%", flex: 1, overflow: "hidden" }}>
            <Typography
              alignSelf="flex-start"
              fontSize="16px"
              color="#0A3243"
              sx={{
                ...(data?.msg.includes("\n") && {
                  whiteSpace: "pre-line"
                }),
                overflowY: "auto",
                overflowX: "hidden",
                maxHeight: "calc(100vh - 300px)",
                width: "100%",
                pr: "8px"
              }}
            >
              {data?.isHTML ? ReactHtmlParser(data?.msg) : data?.msg}
            </Typography>
            {data?.footerMsg && (
              <Typography
                fontSize="16px"
                color="#0A3243"
                sx={{
                  mt: "20px",
                  flexShrink: 0
                }}
              >
                {data.footerMsg}
              </Typography>
            )}
          </Stack>
          <Button 
            onClick={closeInfoModal} 
            variant="contained" 
            sx={{ backgroundColor: "#071F35", flexShrink: 0 }}
          >
            {data?.buttonText || "Okay"}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

// white-space: pre-line;
// overflow: auto;
